var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.24 5.246V3.732H6.76v1.514h1.48zm0 6.022V6.761H6.76v4.507h1.48zM7.5 0c1.37 0 2.638.343 3.804 1.028a7.108 7.108 0 0 1 2.668 2.668A7.376 7.376 0 0 1 15 7.5c0 1.37-.343 2.638-1.028 3.804a7.108 7.108 0 0 1-2.668 2.668A7.376 7.376 0 0 1 7.5 15a7.376 7.376 0 0 1-3.804-1.028 7.243 7.243 0 0 1-2.668-2.686A7.343 7.343 0 0 1 0 7.5c0-1.358.343-2.62 1.028-3.786a7.381 7.381 0 0 1 2.686-2.686A7.343 7.343 0 0 1 7.5 0z","fill":"currentColor","fillRule":"evenodd"}));
}

Info.defaultProps = {"viewBox":"0 0 15 15","width":"15","height":"15"};

module.exports = Info;

Info.default = Info;
